import { api_endpoints, api_host, __debug } from "./constants";

export default class API {
  constructor() {
    if (__debug) {
      console.log("API initialize");
    }
  }

  static soundPreferences(body) {
    let api = new API();
    return api.call(api_endpoints.saveSoundPreferences, {
      body: JSON.stringify(body),
    });
  }

  static userdata() {
    let api = new API();
    return api.call(api_endpoints.userdata);
  }

  

  static account(body) {
    let api = new API();
    return api.call(api_endpoints.account, {
      body: JSON.stringify(body),
    });
  }

  static stripe_session() {
    let api = new API();
    return api.call(api_endpoints.stripe_session);
  }

  static renew_session() {
    let api = new API();
    return api.call(api_endpoints.renew_session);
  }

  static update_subscription() {
    let api = new API();
    return api.call(api_endpoints.update_subscription);
  }

  _checkStatus(response) {
    if (__debug) {
      console.log("_checkStatus");
      console.log(response);
    }

    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      if (__debug) {
        console.log("throw error");
        console.log(response);
      }
      throw new Error(response);
    }
  }

  _checkResponse(response) {
    if (__debug) {
      console.log("_checkResponse");
      console.log(response);
    }

    if (
      typeof response !== "undefined" &&
      typeof response.logout !== "undefined" &&
      response.logout === true
    ) {
      console.log('redirect to login (api)');
      window.location.href = "/login";
    } else if (
      typeof response !== "undefined" &&
      typeof response.nosubscription !== "undefined" &&
      response.nosubscription === true
    ) {
      if (!window.location.href.match(/nosubscription/) && !window.location.href.match(/delete/)) {

        const { settings } = store.getState();
        const { directPayment } = settings;
        console.log(directPayment);

        if (directPayment){
          window.sessionStorage.setItem('directPayment', 'true');
        }
        window.location.href = "/nosubscription";
      }
    } else if (response?.hasSubscription && !response?.hasCard && response.subscription_status != "trialing") {

        window.store.dispatch(window.trialActions.expireTrial());

      
    }

    return response;
  }

  call(endpoint, options) {
    let url = api_host + endpoint;

    if (__debug) {
      console.log("API call: " + url);
    }

    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
    };

    if (localStorage.getItem("JWTtoken")) {
      headers["X-Authorization"] = "Bearer " + localStorage.getItem("JWTtoken");
    }

    if (pusherSocketId) {
      headers["X-Socket-ID"] = pusherSocketId;
    }

    return fetch(url, {
      method: "POST",
      responseType: "json",
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then((response) => response.json())
      .then(this._checkResponse);
  }
}
